var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "请输入检查结果",
        okText: "确认",
        cancelText: "取消",
        width: "500px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            layout: "horizontal",
            model: _vm.form,
            rules: _vm.rules,
            "label-col": { span: 0 },
            "wrapper-col": { span: 24 },
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { prop: "badThings" } },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "padding-right": "40px",
                      },
                      attrs: { span: "8" },
                    },
                    [_vm._v("选择污染物")]
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: "16" } },
                    [
                      _c("a-ext-bad-check-box", {
                        attrs: { param: { projectId: _vm.param.projectId } },
                        model: {
                          value: _vm.form.badThings,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "badThings", $$v)
                          },
                          expression: "form.badThings",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }